import React from "react";
import { Redirect, Route } from "react-router-dom";
import { getStoredToken } from "../services/auth.service";

const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      getStoredToken()
        ? <Component {...props} />
        : <Redirect to={{ pathname: "/login", state: { referrer: props.location.pathname } }} />
    }
  />
);

export default ProtectedRoute;
export { ProtectedRoute };
